import React from 'react'
import Faqheader from './Faqheader'
import Faqdetails from './Faqdetails'

const FAQ = () => {
  return (
    <div>
        <Faqheader/>
        <Faqdetails/>
    </div>
  )
}

export default FAQ